var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-list"},[_c('li',{staticClass:"menu-list__item"},[_vm._t("1")],2),_vm._v(" "),_c('li',{staticClass:"menu-list__item"},[_vm._t("2")],2),_vm._v(" "),_c('li',{staticClass:"menu-list__item"},[_vm._t("3")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d218fd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/MenuList.vue
// module id = null
// module chunks = 